import { manualStoreTypes } from '@gelato-api-ui/core/e-commerce/constants/manual-store-types';
import { EStoreType } from '@gelato-api-ui/core/e-commerce/e-store-type.enum';

export const internalStoreTypes = [...manualStoreTypes, EStoreType.BRANDING, EStoreType.TEMPLATE, EStoreType.MOCKUP];
